module.exports = {
  None: 0,
  In: 1,
  Out: 2,
  InAndOut: 3,
};
